<template>
  <div class="index">
    <div class="index_top">
      <div class="index_top_l bg">
        <div ref="echarts1" id="echarts1"></div>
      </div>
      <div class="index_top_c bg">
        <div class="employment_stats">
          <!-- 左侧：已就业信息 -->
          <div class="stats_left">
            <div class="stat_item">
              <div class="stat_label">已就业人数（人）</div>
              <div class="stat_value main">{{ homedata.sumworkcount }}</div>
            </div>
            <div class="stat_detail">
              <span>少数民族：<em>{{ homedata.fewnationworkrate }}</em></span>
            </div>
            <div class="stat_detail">
              <span>男性：<em>{{ homedata.manworkrate }}</em></span>
              <span class="ml">女性：<em>{{ homedata.womenworkrate }}</em></span>
            </div>
          </div>

          <!-- 中间：重点人群 -->
          <!-- <div class="stats_center">
            <div class="stat_item">
              <div class="stat_label">退役军人（人）</div>
              <div class="stat_value">{{ homedata.tuiyicount }}</div>
            </div>
            <div class="stat_item mt">
              <div class="stat_label">残疾人（人）</div>
              <div class="stat_value">{{ homedata.canjicount }}</div>
            </div>
          </div> -->

          <!-- 右侧：意愿人数 -->
          <!-- <div class="stats_right">
            <div class="badge_item">
              <div class="badge">
                <div ref="echarts2" id="echarts2"></div>
              </div>
              <div class="badge_label">培训意愿<br />人数</div>
            </div>
            <div class="badge_item">
              <div class="badge">
                <div ref="echarts3" id="echarts3"></div>
              </div>
              <div class="badge_label">创业意愿<br />人数</div>
            </div>
            <div class="badge_item">
              <div class="badge">
                <div ref="echarts4" id="echarts4"></div>
              </div>
              <div class="badge_label">返乡就业<br />意愿人数</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="index_top_r bg">
        <div class="gauge_container">
          <div class="gauge_item">
            <div ref="echarts5" id="echarts5"></div>
            <div class="gauge_label">未就业人数（人）</div>
          </div>
          <!-- <div class="gauge_item">
            <div ref="echarts6" id="echarts6"></div>
            <div class="gauge_label">无就业意愿人数（人）</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="index_bottom">
      <div class="index_bottom_l">
        <div class="index_bottom_l_item bg">
          <div class="index_bottom_l_item_title">
            <div>人员年龄分布</div>
          </div>
          <div class="index_bottom_l_item_content">
            <div ref="echarts7" id="echarts7"></div>
          </div>
        </div>
        <!-- <div class="index_bottom_l_item bg">
          <div class="index_bottom_l_item_title">
            <div>文化程度分布</div>
          </div>
          <div class="index_bottom_l_item_content">
            <div ref="echarts8" id="echarts8"></div>
          </div>
        </div> -->
      </div>
      <div class="index_bottom_c bg">
        <div class="index_bottom_c_img" id="index_bottom_c_img">
          <img src="@/assets/images/index/map.png" alt="" srcset=""></img>
          <div :class="['index_bottom_c_mask_item', 'index_bottom_c_mask_item' + item.id, item.classAct]"
            v-for="item in homedata.zhencount" :key="item.id">
            <div class="index_bottom_c_mask_item_label">{{ item.name }}</div>
            <div class="index_bottom_c_mask_item_value">{{ item.counts }}</div>
          </div>
        </div>
      </div>
      <div class="index_bottom_r bg">
        <div class="index_bottom_l_item_title">
          <div>就业行业分布</div>
        </div>
        <div class="index_bottom_r_list">
          <div class="index_bottom_r_item index_bottom_r_item_th">
            <div class="index_bottom_r_item_td">排名</div>
            <div class="index_bottom_r_item_td">就业行业</div>
            <div class="index_bottom_r_item_td">人数</div>
          </div>
          <div class="index_bottom_r_item_main_container">
            <div class="index_bottom_r_item_main" ref="scrollList">
              <div class="index_bottom_r_item" v-for="(item, index) in industryData" :key="index"
                :class="getRowClass(item.rank)">
                <div class="index_bottom_r_item_td rank">{{ item.rank }}</div>
                <div class="index_bottom_r_item_td industry">
                  {{ item.name }}
                </div>
                <div class="index_bottom_r_item_td count">{{ item.count }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-liquidfill";
import { asArray } from "@/utils/array";

export default {
  data() {
    return {
      myChart: null,
      myChart2: null,
      myChart3: null,
      myChart4: null,
      myChart5: null,
      myChart6: null,
      myChart7: null,
      myChart8: null,
      trafficWay: [
        { name: "男性劳动力（人）", value: 0 },
        { name: "女性劳动力（人）", value: 0 },
      ],
      ageData: [],
      educationData: [],
      industryData: [],
      scrollTimer: null,

      homedata: {
        sumusercount: 0,
        sumworkcount: 0,
        noworkcount: 0,
        noworkyiyuancount: 0,
        tuiyicount: 0,
        canjicount: 0,
        istraincount: 0,
        ischuangyecount: 0,
        isfanxiangjiuyecount: 0,
        fewnationworkrate: '0%',
        manworkrate: '0%',
        womenworkrate: '0%',
        zhencount: [{ id: 1, name: "高田镇", counts: 0, classAct: '' },
        { id: 2, name: "木兰乡", counts: 0, classAct: '' },
        { id: 3, name: "小松镇", counts: 0, classAct: '' },
        { id: 4, name: "丰山乡", counts: 0, classAct: '' },
        { id: 5, name: "琴江镇", counts: 0, classAct: '' },
        { id: 6, name: "屏山镇", counts: 0, classAct: '' },
        { id: 7, name: "珠坑乡", counts: 0, classAct: '' },
        { id: 8, name: "大由乡", counts: 0, classAct: '' },
        { id: 9, name: "龙岗乡", counts: 0, classAct: '' },
        { id: 10, name: "横江镇", counts: 0, classAct: '' },
        { id: 11, name: "赣江源区", counts: 0, classAct: '' }]
      },
      zhenindex: 0,
      zhentimer: null,
    };
  },
  mounted() {
    this.webHome()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
      this.scrollTimer = null;
    }
    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
    if (this.myChart2) {
      this.myChart2.dispose();
      this.myChart2 = null;
    }
    if (this.myChart3) {
      this.myChart3.dispose();
      this.myChart3 = null;
    }
    if (this.myChart4) {
      this.myChart4.dispose();
      this.myChart4 = null;
    }
    if (this.myChart5) {
      this.myChart5.dispose();
      this.myChart5 = null;
    }
    if (this.myChart6) {
      this.myChart6.dispose();
      this.myChart6 = null;
    }
    if (this.myChart7) {
      this.myChart7.dispose();
      this.myChart7 = null;
    }
    if (this.myChart8) {
      this.myChart8.dispose();
      this.myChart8 = null;
    }
    if (this.zhentimer) {
      clearInterval(this.zhentimer)
      this.zhentimer = null
    }
  },
  methods: {
    calcLiquidRates(count, total) {
      const rate = total > 0 ? Number(count) / Number(total) : 0
      const r = Math.min(rate, 1)
      return {
        rate: r,
        rate1: r > 1 ? r - 0.05 : r / 2,
        rate2: r > 1 ? r - 0.05 : 0,
      }
    },
    async webHome() {
      let res = await this.$api.webHome()
      if (res.code != 1 || !res.data) return

      const data = res.data
      const sumuser = Number(data.sumusercount) || 1
      const zhencount = asArray(data.zhencount)
      zhencount.forEach(item => { item.classAct = '' })

      const trainRates = this.calcLiquidRates(data.istraincount, sumuser)
      const chuangyeRates = this.calcLiquidRates(data.ischuangyecount, sumuser)
      const fanxiangRates = this.calcLiquidRates(data.isfanxiangjiuyecount, sumuser)

      this.homedata = {
        ...data,
        zhencount: zhencount.length ? zhencount : this.homedata.zhencount,
        noworkrate: (Number(data.noworkcount) / sumuser).toFixed(2),
        noworkyiyuanrate: (Number(data.noworkyiyuancount) / sumuser).toFixed(2),
        trainrate: trainRates.rate,
        trainrate1: trainRates.rate1,
        trainrate2: trainRates.rate2,
        chuangyerate: chuangyeRates.rate,
        chuangyerate1: chuangyeRates.rate1,
        chuangyerate2: chuangyeRates.rate2,
        fanxiangrate: fanxiangRates.rate,
        fanxiangrate1: fanxiangRates.rate1,
        fanxiangrate2: fanxiangRates.rate2,
      }

      this.trafficWay = [
        { name: '男性劳动力（人）', value: Number(data.manusercount) || 0 },
        { name: '女性劳动力（人）', value: Number(data.womanusercount) || 0 },
      ]

      this.ageData = asArray(data.agecount).map(item => ({
        age: item.age,
        male: item.count1,
        female: item.count2,
      }))

      this.educationData = asArray(data.educount).map(item => ({
        name: item.name,
        value: (Number(item.counts) / 10000).toFixed(3),
      }))

      let industryData = asArray(data.hangyecount)
        .filter(item => item.hangye)
        .map(item => ({
          name: item.hangye,
          count: Number(item.counts),
        }))
      industryData.sort((a, b) => b.count - a.count)
      industryData.forEach((item, index) => {
        item.rank = index + 1 < 10 ? `0${index + 1}` : index + 1
      })
      this.industryData = industryData

      this.initEcharts();
      // this.initEcharts2();
      // this.initEcharts3();
      // this.initEcharts4();
      this.initEcharts5();
      // this.initEcharts6();
      this.initEcharts7();
      // this.initEcharts8();
      this.$nextTick(() => {
        window.addEventListener("resize", this.handleResize);
        this.startScroll();
        this.handleMove()
      });
    },
    handleMove() {
      let that = this
      if (!this.zhentimer) {
        this.zhenindex = 0
        this.handleTimer()
      }
      let mapid = document.getElementById('index_bottom_c_img');
      if (!mapid || !asArray(this.homedata.zhencount).length) return
      mapid.addEventListener('mouseenter', function () {
        clearInterval(that.zhentimer)
        that.zhentimer = null
        that.homedata.zhencount.forEach(item => {
          item.classAct = ''
        })
      });
      mapid.addEventListener('mouseleave', function () {
        that.handleTimer()
      });
    },
    handleTimer() {
      let that = this
      if (!that.zhentimer) {
        that.zhentimer = setInterval(() => {
          that.homedata.zhencount.forEach(item => {
            item.classAct = ''
          })
          that.homedata.zhencount[that.zhenindex].classAct = 'index_bottom_c_mask_item_act'
          if (that.zhenindex < that.homedata.zhencount.length - 1) {
            that.zhenindex++
          } else {
            that.zhenindex = 0
          }
        }, 2000)
      }
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
        const option = this.getChartOption1();
        this.myChart.setOption(option);
      }
      if (this.myChart2) {
        this.myChart2.resize();
        const option2 = this.getChartOption2();
        this.myChart2.setOption(option2);
      }
      if (this.myChart3) {
        this.myChart3.resize();
        const option3 = this.getChartOption3();
        this.myChart3.setOption(option3);
      }
      if (this.myChart4) {
        this.myChart4.resize();
        const option4 = this.getChartOption4();
        this.myChart4.setOption(option4);
      }
      if (this.myChart5) {
        this.myChart5.resize();
        const option5 = this.getChartOption5();
        this.myChart5.setOption(option5);
      }
      if (this.myChart6) {
        this.myChart6.resize();
        const option6 = this.getChartOption6();
        this.myChart6.setOption(option6);
      }
      if (this.myChart7) {
        this.myChart7.resize();
        const option7 = this.getChartOption7();
        this.myChart7.setOption(option7);
      }
      if (this.myChart8) {
        this.myChart8.resize();
        const option8 = this.getChartOption8();
        this.myChart8.setOption(option8);
      }
    },
    getChartOption1() {
      // 根据容器宽度计算自适应的尺寸
      const containerWidth = this.$refs.echarts1.offsetWidth;
      const borderWidth = Math.max(8, Math.floor(containerWidth * 0.032)); // 容器宽度的3.2%，最小8px
      const itemWidth = Math.max(8, Math.floor(containerWidth * 0.021)); // 容器宽度的2.1%，最小8px
      const itemHeight = Math.max(8, Math.floor(containerWidth * 0.021)); // 容器宽度的2.1%，最小8px
      const itemGap = Math.max(15, Math.floor(containerWidth * 0.042)); // 容器宽度的4.2%，最小15px

      var totalValue = this.trafficWay.reduce(
        (sum, item) => sum + item.value,
        0
      );
      var nameArray = this.trafficWay.map((item) => item.name);
      var data = [];
      var color = ["#249ADF", "#FCA12F"];

      for (var i = 0; i < this.trafficWay.length; i++) {
        data.push({
          value: this.trafficWay[i].value,
          name: this.trafficWay[i].name,
          itemStyle: {
            normal: {
              borderWidth: borderWidth,
              borderColor: color[i],
            },
          },
        });
      }
      var seriesOption = [
        {
          name: "",
          type: "pie",
          clockWise: false,
          radius: ["60%", "60%"],
          hoverAnimation: false,
          center: ["31%", "50%"],
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
            },
          },
          data: data,
        },
      ];

      var option = {
        color: color,
        graphic: {
          elements: [
            {
              type: "text",
              z: 4,
              left: "22%",
              top: "55%",
              style: {
                text: "总劳动力人数",
                fill: "#fff",
                fontSize: "0.073rem",
                textAlign: "center",
              },
            },
            {
              type: "text",
              z: 4,
              left: "24.5%",
              top: "42%",
              style: {
                text: String(this.homedata.sumusercount || totalValue),
                fill: "#FFB74D",
                fontSize: "0.083rem",
                fontWeight: "bold",
                textAlign: "center",
              },
            },
          ],
        },
        tooltip: {
          show: false,
        },
        legend: {
          icon: "circle",
          orient: "vertical",
          data: nameArray.map((name) => ({
            name: name,
            icon: "circle",
            textStyle: {
              color: "#fff",
              fontSize: "0.073rem",
            },
          })),
          left: "55%",
          top: "center",
          align: "left",
          itemGap: itemGap,
          itemWidth: itemWidth,
          itemHeight: itemHeight,
          formatter: (name) => {
            var item = this.trafficWay.find((item) => item.name === name);
            return name + "\n\n" + item.value;
          },
          textStyle: {
            color: "#fff",
            fontSize: "0.063rem",
            rich: {
              value: {
                color: "#fff",
                fontSize: "0.083rem",
                fontWeight: "bold",
              },
            },
          },
        },
        toolbox: {
          show: false,
        },
        series: seriesOption,
      };

      return option;
    },
    initEcharts() {
      this.myChart = echarts.init(this.$refs.echarts1);
      const option = this.getChartOption1();
      this.myChart.setOption(option);
    },
    getChartOption2() {
      // 根据父容器尺寸计算自适应的属性
      const containerWidth = this.$refs.echarts2
        ? this.$refs.echarts2.offsetWidth
        : 75;
      const fontSize = Math.max(10, Math.floor(containerWidth * 0.24)); // 容器宽度的24%
      const borderWidth = Math.max(2, Math.floor(containerWidth * 0.04)); // 容器宽度的4%
      const radius = "95%"; // 使用百分比自适应，填满容器
      const borderDistance = 0; // 无间距

      var option = {
        title: {
          text: this.homedata.istraincount,
          textStyle: {
            fontSize: fontSize,
            fontFamily: "Arial",
            fontWeight: "bold",
            color: "#fff",
          },
          x: "center",
          y: "center",
        },
        series: [
          {
            type: "liquidFill",
            radius: radius,
            // data: [0.6, 0.55, 0.5],
            data: [this.homedata.trainrate, this.homedata.trainrate1, this.homedata.trainrate2],
            center: ["50%", "50%"],
            amplitude: 8,
            waveAnimation: true,
            animationDuration: 3000,
            animationDurationUpdate: 1000,
            backgroundStyle: {
              color: "transparent",
            },
            outline: {
              show: true,
              borderDistance: borderDistance,
              itemStyle: {
                borderWidth: borderWidth,
                borderColor: "#4A6DF4",
                shadowBlur: 5,
                shadowColor: "rgba(74, 144, 226, 0.5)",
              },
            },
            color: [
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "#4A6DF4" },
                  { offset: 1, color: "#2248F3" },
                ],
                globalCoord: false,
              },
            ],
            label: {
              show: false,
            },
          },
        ],
      };

      return option;
    },
    initEcharts2() {
      this.myChart2 = echarts.init(this.$refs.echarts2);
      const option = this.getChartOption2();
      this.myChart2.setOption(option);
    },
    getChartOption3() {
      // 根据父容器尺寸计算自适应的属性
      const containerWidth = this.$refs.echarts3
        ? this.$refs.echarts3.offsetWidth
        : 75;
      const fontSize = Math.max(10, Math.floor(containerWidth * 0.24));
      const borderWidth = Math.max(2, Math.floor(containerWidth * 0.04));
      const radius = "95%";
      const borderDistance = 0;

      var option = {
        title: {
          text: this.homedata.ischuangyecount,
          textStyle: {
            fontSize: fontSize,
            fontFamily: "Arial",
            fontWeight: "bold",
            color: "#fff",
          },
          x: "center",
          y: "center",
        },
        series: [
          {
            type: "liquidFill",
            radius: radius,
            // data: [0.6, 0.55, 0.5],
            data: [this.homedata.chuangyerate, this.homedata.chuangyerate1, this.homedata.chuangyerate2],
            center: ["50%", "50%"],
            amplitude: 8,
            waveAnimation: true,
            animationDuration: 3000,
            animationDurationUpdate: 1000,
            backgroundStyle: {
              color: "transparent",
            },
            outline: {
              show: true,
              borderDistance: borderDistance,
              itemStyle: {
                borderWidth: borderWidth,
                borderColor: "#F1F141",
                shadowBlur: 5,
                shadowColor: "rgba(92, 107, 192, 0.5)",
              },
            },
            color: [
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "#F1F141" },
                  { offset: 1, color: "#D06431" },
                ],
                globalCoord: false,
              },
            ],
            label: {
              show: false,
            },
          },
        ],
      };

      return option;
    },
    initEcharts3() {
      this.myChart3 = echarts.init(this.$refs.echarts3);
      const option = this.getChartOption3();
      this.myChart3.setOption(option);
    },
    getChartOption4() {
      // 根据父容器尺寸计算自适应的属性
      const containerWidth = this.$refs.echarts4
        ? this.$refs.echarts4.offsetWidth
        : 75;
      const fontSize = Math.max(10, Math.floor(containerWidth * 0.24));
      const borderWidth = Math.max(2, Math.floor(containerWidth * 0.04));
      const radius = "95%";
      const borderDistance = 0;

      var option = {
        title: {
          text: this.homedata.isfanxiangjiuyecount,
          textStyle: {
            fontSize: fontSize,
            fontFamily: "Arial",
            fontWeight: "bold",
            color: "#fff",
          },
          x: "center",
          y: "center",
        },
        series: [
          {
            type: "liquidFill",
            radius: radius,
            // data: [0.6, 0.55, 0.5],
            data: [this.homedata.fanxiangrate, this.homedata.fanxiangrate1, this.homedata.fanxiangrate2],
            center: ["50%", "50%"],
            amplitude: 8,
            waveAnimation: true,
            animationDuration: 3000,
            animationDurationUpdate: 1000,
            backgroundStyle: {
              color: "transparent",
            },
            outline: {
              show: true,
              borderDistance: borderDistance,
              itemStyle: {
                borderWidth: borderWidth,
                borderColor: "#6DE6DC",
                shadowBlur: 5,
                shadowColor: "rgba(38, 166, 154, 0.5)",
              },
            },
            color: [
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "#6DE6DC" },
                  { offset: 1, color: "#1EC18D" },
                ],
                globalCoord: false,
              },
            ],
            label: {
              show: false,
            },
          },
        ],
      };

      return option;
    },
    initEcharts4() {
      this.myChart4 = echarts.init(this.$refs.echarts4);
      const option = this.getChartOption4();
      this.myChart4.setOption(option);
    },
    getChartOption5() {
      // 根据父容器尺寸计算自适应的属性
      const containerWidth = this.$refs.echarts5
        ? this.$refs.echarts5.offsetWidth
        : 200;
      const fontSize = Math.max(16, Math.floor(containerWidth * 0.12));
      const lineWidth = Math.max(14, Math.floor(containerWidth * 0.04));

      var option = {
        series: [
          // 主仪表盘
          {
            type: "gauge",
            startAngle: 200,
            endAngle: -20,
            radius: "80%",
            center: ["50%", "60%"],
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                width: lineWidth,
                color: [
                  [
                    this.homedata.noworkrate, //值
                    {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 1,
                      y2: 0,
                      colorStops: [
                        { offset: 0, color: "#2288EB" },
                        { offset: 1, color: "#2CE7AE" },
                      ],
                    },
                  ],
                  [1, "rgba(74, 109, 244, 0.15)"],
                ],
                shadowColor: "rgba(74, 109, 244, 0.7)",
                shadowBlur: 8,
              },
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              show: true,
              offsetCenter: [0, "-5%"],
              textStyle: {
                fontSize: fontSize,
                fontWeight: "bold",
                color: "#00f1ff",
                textShadowColor: "rgba(74, 109, 244, 0.5)",
                textShadowBlur: 10,
              },
              formatter: this.homedata.noworkcount,
            },
            title: {
              show: false,
            },
            data: [
              {
                value: this.homedata.noworkcount,
              },
            ],
          },
          // 内圈发光环
          {
            type: "pie",
            radius: ["55%", "58%"],
            center: ["50%", "60%"],
            hoverAnimation: false,
            startAngle: 200,
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  color: {
                    type: "radial",
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [
                      { offset: 0, color: "rgba(74, 109, 244, 0.3)" },
                      { offset: 1, color: "rgba(74, 109, 244, 0)" },
                    ],
                  },
                },
              },
            ],
          },
        ],
      };

      return option;
    },
    initEcharts5() {
      this.myChart5 = echarts.init(this.$refs.echarts5);
      const option = this.getChartOption5();
      this.myChart5.setOption(option);
    },
    getChartOption6() {
      // 根据父容器尺寸计算自适应的属性
      const containerWidth = this.$refs.echarts6
        ? this.$refs.echarts6.offsetWidth
        : 200;
      const fontSize = Math.max(16, Math.floor(containerWidth * 0.12));
      const lineWidth = Math.max(14, Math.floor(containerWidth * 0.04));

      var option = {
        series: [
          // 主仪表盘
          {
            type: "gauge",
            startAngle: 200,
            endAngle: -20,
            radius: "80%",
            center: ["50%", "60%"],
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                width: lineWidth,
                color: [
                  [
                    this.homedata.noworkyiyuanrate,
                    {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 1,
                      y2: 0,
                      colorStops: [
                        { offset: 0, color: "#F6AE39" },
                        { offset: 1, color: "#F6EB57" },
                      ],
                    },
                  ],
                  [1, "rgba(241, 241, 65, 0.15)"],
                ],
                shadowColor: "rgba(241, 241, 65, 0.7)",
                shadowBlur: 8,
              },
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              show: true,
              offsetCenter: [0, "-5%"],
              textStyle: {
                fontSize: fontSize,
                fontWeight: "bold",
                color: "#f6ec58",
                textShadowColor: "rgba(241, 241, 65, 0.5)",
                textShadowBlur: 10,
              },
              formatter: this.homedata.noworkyiyuancount,
            },
            title: {
              show: false,
            },
            data: [
              {
                value: this.homedata.noworkyiyuancount,
              },
            ],
          },
          // 内圈发光环
          {
            type: "pie",
            radius: ["55%", "58%"],
            center: ["50%", "60%"],
            hoverAnimation: false,
            startAngle: 200,
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  color: {
                    type: "radial",
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [
                      { offset: 0, color: "rgba(241, 241, 65, 0.3)" },
                      { offset: 1, color: "rgba(241, 241, 65, 0)" },
                    ],
                  },
                },
              },
            ],
          },
        ],
      };

      return option;
    },
    initEcharts6() {
      this.myChart6 = echarts.init(this.$refs.echarts6);
      const option = this.getChartOption6();
      this.myChart6.setOption(option);
    },
    getChartOption7() {
      // 根据容器尺寸计算自适应属性
      const containerWidth = this.$refs.echarts7
        ? this.$refs.echarts7.offsetWidth
        : 473;
      const barHeight = Math.max(12, Math.floor(containerWidth * 0.025));
      const fontSize = Math.max(10, Math.floor(containerWidth * 0.028));

      const categories = this.ageData.map((item) => item.age);
      const maleData = this.ageData.map((item) => -item.male); // 男性数据取负值，向左显示
      const femaleData = this.ageData.map((item) => item.female);
      const maxValue = Math.max(
        1,
        ...this.ageData.map((item) => Math.max(item.male, item.female))
      );

      var option = {
        grid: {
          left: "10%",
          right: "20%",
          top: "15%",
          bottom: "8%",
        },
        legend: {
          data: ["男", "女"],
          top: "3%",
          left: "center",
          textStyle: {
            color: "#fff",
            fontSize: fontSize,
          },
          itemWidth: fontSize * 1.2,
          itemHeight: fontSize * 0.8,
          itemGap: fontSize * 1.5,
        },
        xAxis: [
          {
            type: "value",
            position: "top",
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            min: -maxValue,
            max: maxValue,
          },
          {
            type: "value",
            position: "bottom",
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            min: -maxValue,
            max: maxValue,
          },
        ],
        yAxis: {
          type: "category",
          position: "left",
          data: categories,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            fontSize: fontSize,
            align: "center",
            margin: fontSize * 6,
          },
        },
        series: [
          {
            name: "男",
            type: "bar",
            barWidth: barHeight,
            stack: "one",
            label: {
              show: true,
              position: "left",
              color: "#fff",
              fontSize: fontSize - 2,
              formatter: function (params) {
                return Math.abs(params.value);
              },
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "#34518f" },
                  { offset: 1, color: "rgba(53, 66, 163, 0.33)" },
                ],
              },
              borderRadius: [3, 0, 0, 3],
            },
            data: maleData,
          },
          {
            name: "女",
            type: "bar",
            barWidth: barHeight,
            stack: "one",
            label: {
              show: true,
              position: "right",
              color: "#fff",
              fontSize: fontSize - 2,
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "#6dcde6" },
                  { offset: 1, color: "#264bf3" },
                ],
              },
              borderRadius: [0, 3, 3, 0],
            },
            data: femaleData,
          },
        ],
      };

      return option;
    },
    initEcharts7() {
      this.myChart7 = echarts.init(this.$refs.echarts7);
      const option = this.getChartOption7();
      this.myChart7.setOption(option);
    },
    getChartOption8() {
      // 根据容器尺寸计算自适应属性
      const containerWidth = this.$refs.echarts8
        ? this.$refs.echarts8.offsetWidth
        : 433;
      const barWidth = Math.max(10, Math.floor(containerWidth * 0.04));
      const fontSize = Math.max(10, Math.floor(containerWidth * 0.018));

      const categories = this.educationData.map((item) => item.name);
      const values = this.educationData.map((item) => item.value);
      const maxValue = Math.max(1, ...values.map(Number));

      var option = {
        grid: {
          left: "2%",
          right: "1%",
          top: "18%",
          bottom: "5%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          borderColor: "rgba(255, 255, 255, 0.2)",
          textStyle: {
            color: "#fff",
            fontSize: fontSize
          },
          formatter: "{b}: {c}万人",
        },
        xAxis: {
          type: "category",
          data: categories,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
            fontSize: fontSize,
            interval: 0,
            rotate: 0,
            margin: 10,
          },
        },
        yAxis: {
          type: "value",
          name: "人数/万人",
          nameTextStyle: {
            color: "#d8d8d8",
            fontSize: fontSize,
            padding: [0, 0, 0, -10],
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.2)",
              width: 1,
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.2)",
              width: 1,
            },
            length: 5,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.1)",
              type: "dashed",
            },
          },
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: fontSize - 2,
          },
          max: maxValue + 1,
        },
        series: [
          {
            type: "bar",
            barWidth: barWidth,
            data: values,
            label: {
              show: false,
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  { offset: 0, color: "#D7B10F" },
                  { offset: 1, color: "#113450" },
                ],
              },
              borderRadius: [3, 3, 0, 0],
              borderColor: "#F6EB57",
              borderWidth: 1,
              shadowColor: "rgba(241, 241, 65, 0.5)",
              shadowBlur: 8,
            },
            emphasis: {
              itemStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    { offset: 0, color: "rgba(246, 235, 87, 0.5)" },
                    { offset: 1, color: "#F6EB57" },
                  ],
                },
              },
            },
          },
        ],
      };

      return option;
    },
    initEcharts8() {
      this.myChart8 = echarts.init(this.$refs.echarts8);
      const option = this.getChartOption8();
      this.myChart8.setOption(option);
    },
    getRowClass(rank) {
      // 根据排名设置不同的样式类
      const num = parseInt(rank);
      if (num === 1) return "rank-1";
      if (num === 2) return "rank-2";
      if (num === 3) return "rank-3";
      return "";
    },
    startScroll() {
      const scrollList = this.$refs.scrollList;
      if (!scrollList) return;

      // 复制一份数据用于无缝滚动
      const items = scrollList.children;
      if (items.length === 0) return;

      // 克隆第一组数据追加到末尾实现无缝
      const cloneItems = Array.from(items).map((item) => item.cloneNode(true));
      cloneItems.forEach((item) => scrollList.appendChild(item));

      let scrollTop = 0;
      const itemHeight = items[0].offsetHeight;
      const totalHeight = itemHeight * this.industryData.length;

      const scroll = () => {
        this.scrollTimer = setInterval(() => {
          scrollTop += 1;

          // 当滚动到一半时（原始数据滚动完）重置到开始位置
          if (scrollTop >= totalHeight) {
            scrollTop = 0;
            scrollList.style.transition = "none";
            scrollList.style.transform = `translateY(0px)`;

            // 强制重绘后继续滚动
            setTimeout(() => {
              scrollList.style.transition = "transform 0.5s linear";
            }, 50);
          } else {
            scrollList.style.transform = `translateY(-${scrollTop}px)`;
          }
        }, 50);
      };

      // 鼠标移入暂停
      scrollList.addEventListener("mouseenter", () => {
        if (this.scrollTimer) {
          clearInterval(this.scrollTimer);
          this.scrollTimer = null;
        }
      });

      // 鼠标移出继续
      scrollList.addEventListener("mouseleave", () => {
        scroll();
      });

      // 开始滚动
      scroll();
    },
  },
};
</script>
<style scoped lang="scss">
.index {
  padding: 20px 30px 24px;

  .bg {
    width: 100%;
    height: 100%;
    background-image: url("@/assets/images/index/bg1.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 0;
  }

  .index_top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;

    .index_top_l {
      width: 473px;
      height: 200px;

      #echarts1 {
        width: 473px;
        height: 200px;
      }
    }

    .index_top_c {
      width: 870px;
      height: 200px;
      background-image: url("@/assets/images/index/bg2.png");
      box-sizing: border-box;

      display: flex;
      align-items: center;
      justify-content: center;

      .employment_stats {
        display: flex;
        align-items: center;
        height: 100%;

        .stats_left {
          width: 274px;
          text-align: center;

          .stat_item {
            margin-bottom: 10px;
          }

          .stat_label {
            font-size: 15px;
            color: #fff;
            margin-bottom: 8px;
          }

          .stat_value {
            font-size: 30px;
            font-weight: bold;
            color: #ffdb15;

            &.main {
              font-size: 32px;
            }
          }

          .stat_detail {
            font-size: 15px;
            color: #eff7ff;
            margin-top: 8px;

            em {
              color: #eff7ff;
              font-style: normal;
              margin-left: 4px;
            }

            .ml {
              margin-left: 20px;
            }
          }
        }

        .stats_center {
          padding: 0 0 0 32px;
          text-align: center;
          width: 160px;
          margin-right: 120px;

          .stat_item {
            margin-bottom: 10px;

            &.mt {
              margin-top: 20px;
            }
          }

          .stat_label {
            font-size: 14px;
            color: #fff;
            margin-bottom: 8px;
          }

          .stat_value {
            font-size: 28px;
            font-weight: bold;
            color: #ffdb15;
          }
        }

        .stats_right {
          display: flex;
          gap: 20px;
          align-items: center;

          .badge_item {
            text-align: center;

            .badge {
              width: 75px;
              height: 75px;
              margin: 0 auto 8px;

              #echarts2,
              #echarts3,
              #echarts4 {
                width: 100%;
                height: 100%;
              }
            }
          }

          .badge_label {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.6);
            line-height: 16px;
          }
        }
      }
    }

    .index_top_r {
      width: 470px;
      height: 200px;
      padding: 10px 30px;
      box-sizing: border-box;

      .gauge_container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        gap: 30px;

        .gauge_item {
          text-align: center;

          #echarts5,
          #echarts6 {
            width: 160px;
            height: 140px;
            margin: 0 auto;
          }

          .gauge_label {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.7);
            margin-top: -5px;
            line-height: 1.4;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .index_bottom {
    display: flex;
    justify-content: space-between;

    .index_bottom_l {
      width: 473px;
      height: 650px;

      .index_bottom_l_item {
        width: 100%;
        height: 314px;
        background-image: url("@/assets/images/index/bg3.png");

        &:first-child {
          margin-bottom: 22px;
        }

        .index_bottom_l_item_content {
          height: 255px;
          padding: 10px 20px;

          #echarts7,
          #echarts8 {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .index_bottom_c {
      width: 870px;
      height: 650px;
      background-image: url("@/assets/images/index/bg5.png");
      display: flex;
      align-items: center;
      justify-content: center;

      .index_bottom_c_img {
        width: 517px;
        height: 615px;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }

        .index_bottom_c_mask_item {
          min-width: 102px;
          height: 68px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          cursor: pointer;

          .index_bottom_c_mask_item_label {
            height: 11px;
            line-height: 11px;
            font-size: 12px;
            color: #ffffff;
          }

          .index_bottom_c_mask_item_value {
            height: 19px;
            line-height: 19px;
            font-size: 20px;
            color: #ffdb15;
            display: none;
            margin-top: 10px;
          }

          &:hover {
            background-color: rgba(0, 0, 0, 0.8);
            border-radius: 4px;
            flex-direction: column;
            align-items: flex-start;
            padding: 0 15px;

            .index_bottom_c_mask_item_label {
              height: 13px;
              line-height: 13px;
              font-size: 14px;
            }

            .index_bottom_c_mask_item_value {
              display: block;
            }
          }
        }

        .index_bottom_c_mask_item_act {
          background-color: rgba(0, 0, 0, 0.8);
          border-radius: 4px;
          flex-direction: column;
          align-items: flex-start;
          padding: 0 15px;

          .index_bottom_c_mask_item_label {
            height: 13px;
            line-height: 13px;
            font-size: 14px;
          }

          .index_bottom_c_mask_item_value {
            display: block;
          }
        }

        .index_bottom_c_mask_item1 {
          top: 88px;
          left: 373px;
        }

        .index_bottom_c_mask_item2 {
          top: 30px;
          left: 265px;
        }

        .index_bottom_c_mask_item3 {
          top: 119px;
          left: 167px;
        }

        .index_bottom_c_mask_item4 {
          top: 148px;
          left: 286px;
        }

        .index_bottom_c_mask_item5 {
          top: 195px;
          left: 186px;
        }

        .index_bottom_c_mask_item6 {
          top: 337px;
          left: 123px;
        }

        .index_bottom_c_mask_item7 {
          top: 356px;
          left: 199px;
        }

        .index_bottom_c_mask_item8 {
          top: 416px;
          left: 28px;
        }

        .index_bottom_c_mask_item9 {
          top: 455px;
          left: 93px;
        }

        .index_bottom_c_mask_item10 {
          top: 444px;
          left: 223px;
        }

        .index_bottom_c_mask_item11 {
          top: 516px;
          left: 157px;
        }

        .index_bottom_c_mask_item12 {
          top: 245px;
          left: 186px;
        }
      }
    }

    .index_bottom_r {
      width: 470px;
      height: 650px;
      background-image: url("@/assets/images/index/bg6.png");
      padding: 20px;
      box-sizing: border-box;

      .index_bottom_r_list {
        height: calc(100% - 58px);
        display: flex;
        flex-direction: column;

        .index_bottom_r_item_th {
          display: flex;
          justify-content: space-between;
          padding: 15px 20px;
          // background: rgba(255, 255, 255, 0.05);
          // border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          flex-shrink: 0;

          .index_bottom_r_item_td {
            color: rgba(255, 255, 255, .2);
            font-size: 14px;
            font-weight: bold;

            &:nth-child(1) {
              width: 60px;
              text-align: center;
            }

            &:nth-child(2) {
              flex: 1;
              text-align: center;
            }

            &:nth-child(3) {
              width: 80px;
              text-align: center;
            }
          }
        }

        .index_bottom_r_item_main_container {
          height: calc(100% - 50px);
          overflow: hidden;
        }

        .index_bottom_r_item_main {
          flex: 1;
          overflow: hidden;
          position: relative;

          .index_bottom_r_item {
            display: flex;
            justify-content: space-between;
            padding: 12px 20px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
            transition: background 0.3s;

            &:hover {
              background: rgba(255, 255, 255, 0.05);
            }

            &:nth-child(1) {
              background-image: url("@/assets/images/index/1.png");
              background-size: contain;
              background-repeat: no-repeat;
              background-position: left center;
            }

            &:nth-child(2) {
              background-image: url("@/assets/images/index/2.png");
              background-size: contain;
              background-repeat: no-repeat;
              background-position: left center;
            }

            &:nth-child(3) {
              background-image: url("@/assets/images/index/3.png");
              background-size: contain;
              background-repeat: no-repeat;
              background-position: left center;
            }

            .index_bottom_r_item_td {
              color: rgba(255, 255, 255, 0.6);
              font-size: 13px;

              &.rank {
                width: 60px;
                text-align: center;
                font-weight: bold;
              }

              &.industry {
                flex: 1;
                text-align: left;
                padding: 0 10px;
              }

              &.count {
                width: 80px;
                text-align: center;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  .index_bottom_l_item_title {
    width: 100%;
    height: 58px;
    background-image: url("@/assets/images/index/bt.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    font-size: 22px;
    padding-top: 17px;
    padding-left: 49px;

    div {
      background: linear-gradient(180deg,
          #ffffff 0%,
          #b8e3ff 50%,
          #7bc4ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      font-weight: bold;
      letter-spacing: 2px;
    }
  }
}
</style>